export const SAVINGS_ICONS = {
  lyrics: <path d="M6 3h9l4 4v14H6zM15 3v5h4M9 12h7M9 16h7M9 8h2" />,
  folder: <path d="M3 7h7l2 2h9v10H3zM3 7V5h7l2 2" />,
};
